// document.addEventListener("DOMContentLoaded", () => {
//   const buttons = document.querySelectorAll(".c_btn");

//   buttons.forEach((button) => {
//     button.addEventListener("click", (event) => {
//       event.preventDefault(); // デフォルトのリンク動作を停止
//       const targetUrl = button.getAttribute("href"); // 遷移先URLを取得
//       const isNewTab = button.getAttribute("target") === "_blank"; // 別タブ判定

//       // 0.2秒後に遷移または別タブで開く
//       setTimeout(() => {
//         if (isNewTab) {
//           window.open(targetUrl, "_blank"); // 別タブで開く
//         } else {
//           window.location.href = targetUrl; // 同じタブで遷移
//         }
//       }, 200); // 200ms = 0.2秒
//     });
//   });
// });

// #mv .mvSwiper 初期化（フェード切り替え）
new Swiper(".mvSwiper", {
  loop: true,
  // ゆったりとしたアニメーションに調整
  speed: 1500, // フェード時間（ms）
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 4000, // 次スライドまでの待ち時間（ms）
    disableOnInteraction: false,
  },
  pagination: {
    el: "#mv .swiper-pagination",
    clickable: true,
  },
});

// #voice .voiceSwiper 初期化
let _voiceSwiper = null;
const _voiceSpMQ = window.matchMedia("(max-width: 767px)");

const _initVoiceSwiper = () => {
  if (_voiceSpMQ.matches) {
    // SP 幅のときのみ初期化（未初期化の場合）
    const voiceEl = document.querySelector(".voiceSwiper");
    if (!voiceEl) {
      // 要素が無いページでは何もしない
      return;
    }
    if (!_voiceSwiper) {
      _voiceSwiper = new Swiper(".voiceSwiper", {
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        pagination: {
          el: "#voice .swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: "#voice .swiper-button-next",
          prevEl: "#voice .swiper-button-prev",
        },
      });
    }
  } else {
    // PC 幅のときは破棄（初期化済みの場合）
    if (_voiceSwiper) {
      _voiceSwiper.destroy(true, true);
      _voiceSwiper = null;
    }
  }
};

// 初回実行
_initVoiceSwiper();

// 画面幅変更時にも追従
if (typeof _voiceSpMQ.addEventListener === "function") {
  _voiceSpMQ.addEventListener("change", _initVoiceSwiper);
} else if (typeof _voiceSpMQ.addListener === "function") {
  // Safari 古めの対応
  _voiceSpMQ.addListener(_initVoiceSwiper);
}

// 初回ロード時にハッシュがある場合のみ、レイアウト確定後に再整列
// （SP の Swiper 初期化やフォント適用後の高さ変化で着地がずれるのを防ぐ）
const _realignInitialHash = () => {
  const hash = window.location.hash;
  if (!hash || hash === "#top") return;
  const target = document.getElementById(hash.slice(1));
  if (!target) return;

  const getTopOcclusion = () => {
    const header = document.getElementById("header");
    if (!header) return 0;
    const headerRect = header.getBoundingClientRect();
    // 全デバイスで「ジャンプ先上端 = ヘッダー下端」
    return Math.max(0, headerRect.bottom);
  };

  const run = () => {
    const offset = getTopOcclusion();
    const y = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(0, y), behavior: "auto" });
  };

  // 初回 + 遅延（Swiper/autoplay/font 適用後）で2回合わせる
  requestAnimationFrame(() => requestAnimationFrame(run));
  setTimeout(run, 280);
  setTimeout(run, 700);
};

window.addEventListener("load", _realignInitialHash, { once: true });
